import ANFImage from '../anfImage/ANFImage';

export function getCvvImageUrl() {
  return ANFImage
    .instance()
    .setImageName('cvv_image')
    .setExtensionType(ANFImage.extensionTypes.PNG)
    .setSizePresetEnabled(false)
    .url;
}
